import { ViewComfyRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { DashboardTemplatesList } from './DashboardTemplatesList';

export const DashboardTemplates = () => {
  return (
    <Stack spacing={4}>
      <Stack>
        <Typography variant="h6">
          <Box component="span" mr={1}>
            <ViewComfyRounded
              sx={{
                color: 'text.secondary',
              }}
              fontSize="medium"
            />
          </Box>
          List of Templates
        </Typography>
        <Typography variant="subtitle2" color="text.disabled">
          These are the dashboards marked as templates for your organization.
          These will be available to others when they create new dashboards.
        </Typography>
      </Stack>
      <DashboardTemplatesList />
    </Stack>
  );
};
